import { Row } from "antd";
import { Container, Label } from "../../../../styles";
import { AnticipationFeeData, OlderFeeProps } from "../../types";
import { FeeGrid, FeeItem, FeeLabel, FeeValue, TableCard } from "../../styles";
import { formatMoney } from "../../../../../../utils/generalFormat";

const OlderFee: React.FC<OlderFeeProps> = ({ data }) => {
  return (
    <Container style={{ padding: "0px" }}>
      <Row style={{ marginBottom: 8 }}>
        <Label>Taxas Atuais:</Label>
      </Row>

      <TableCard>
        <FeeGrid>
          <FeeItem>
            <FeeLabel>Ad Valorem</FeeLabel>
            <FeeValue>{data.adValorem?.toFixed(4)} %</FeeValue>
          </FeeItem>

          <FeeItem>
            <FeeLabel>IOF Diário</FeeLabel>
            <FeeValue>{data.dailyIof?.toFixed(4)} %</FeeValue>
          </FeeItem>

          <FeeItem>
            <FeeLabel>IOF Adicional</FeeLabel>
            <FeeValue>{data.additionalIof?.toFixed(4)} %</FeeValue>
          </FeeItem>

          <FeeItem>
            <FeeLabel>Valor da Operação</FeeLabel>
            <FeeValue>{formatMoney(data.operationFee)}</FeeValue>
          </FeeItem>
        </FeeGrid>
      </TableCard>
    </Container>
  );
};

export default OlderFee;
